import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  showSpinner = false;

  constructor() {}

  public show() {
    this.showSpinner = true;
  }

  public hide() {
    this.showSpinner = false;
  }
}
